<template>
  <div style="background: #fff; color: #000; min-height: 100vh; padding: 10px; font-size: 14px;">
    <!-- 顶部控制栏 -->
    <div style="display: flex; align-items: center; gap: 20px; margin-bottom: 15px; background: #f5f5f5; padding: 10px 20px; border: 1px solid #e8e8e8;">
      <el-switch
        v-model="switchType"
        :active-value="1"
        :inactive-value="0"
        active-text="编辑模式"
        inactive-text="查看模式"
        @change="handleSwitchChange"
      ></el-switch>
      <el-button
        type="primary"
        @click="handleSave"
      >
        {{ isSaving ? "保存中..." : "保存修改" }}
      </el-button>
    </div>

    <!-- 主体三栏布局 -->
    <div style="display: flex; gap: 15px;">
      <!-- 左侧区域 -->
      <div style="flex: 1; display: flex; flex-direction: column; gap: 15px;">
        <!-- 1. 园区概况 -->
        <div style="border: 1px solid #ccc; padding: 15px; background: #fafafa;">
          <h3 style="margin: 0 0 15px 0; text-align: center;">园区概况</h3>
          <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
            <span>房屋总面积：</span>
            <div style="display: flex; align-items: center; gap: 5px;">
              <input
                type="number"
                v-model.number="overviewData.totalArea"
                :disabled="switchType !== 1"
                style="background: #fff; border: 1px solid #ccc; color: #000; padding: 4px 6px; width: 100px;"
              />
              <span>m²</span>
            </div>
          </div>
          <div style="display: flex; justify-content: space-between; align-items: center;">
            <span>房源总数：</span>
            <div style="display: flex; align-items: center; gap: 5px;">
              <input
                type="number"
                v-model.number="overviewData.totalHouse"
                :disabled="switchType !== 1"
                style="background: #fff; border: 1px solid #ccc; color: #000; padding: 4px 6px; width: 100px;"
              />
              <span>套</span>
            </div>
          </div>
        </div>

        <!-- 2. 园区人数趋势（12个月） -->
        <div style="border: 1px solid #ccc; padding: 15px; background: #fafafa;">
          <h3 style="margin: 0 0 15px 0; text-align: center;">园区人数趋势</h3>
          <div style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 8px;">
            <div v-for="(item, index) in peopleTrendList" :key="index" style="display: flex; align-items: center; gap: 4px;">
              <span style="width: 25px;">{{ item.month }}</span>
              <input
                type="number"
                v-model.number="item.value"
                :disabled="switchType !== 1"
                style="background: #fff; border: 1px solid #ccc; color: #000; padding: 3px 4px; width: 60px;"
              />
            </div>
          </div>
        </div>

        <!-- 3. 能耗数据（12个月水费+电费） -->
        <div style="border: 1px solid #ccc; padding: 15px; background: #fafafa;">
          <h3 style="margin: 0 0 15px 0; text-align: center;">能耗数据</h3>
          <!-- 水费行 -->
          <div style="margin-bottom:10px;">
            <div style="font-weight:bold;margin-bottom:6px;">水费(元)</div>
            <div style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 8px;">
              <div v-for="(item, index) in waterTrendList" :key="'water'+index" style="display: flex; align-items: center; gap: 4px;">
                <span style="width: 25px;">{{ item.month }}</span>
                <input
                  type="number"
                  v-model.number="item.value"
                  :disabled="switchType !== 1"
                  style="background: #fff; border: 1px solid #ccc; color: #000; padding: 3px 4px; width: 60px;"
                />
              </div>
            </div>
          </div>
          <!-- 电费行 -->
          <div>
            <div style="font-weight:bold;margin-bottom:6px;">电费(元)</div>
            <div style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 8px;">
              <div v-for="(item, index) in electricTrendList" :key="'elec'+index" style="display: flex; align-items: center; gap: 4px;">
                <span style="width: 25px;">{{ item.month }}</span>
                <input
                  type="number"
                  v-model.number="item.value"
                  :disabled="switchType !== 1"
                  style="background: #fff; border: 1px solid #ccc; color: #000; padding: 3px 4px; width: 60px;"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 中间区域 -->
      <div style="flex: 1.4; display: flex; flex-direction: column; gap: 15px;">
        <!-- 4. 视频介绍【修改上传模块】 -->
        <div style="border: 1px solid #ccc; padding: 15px; background: #fafafa;">
          <h3 style="margin: 0 0 15px 0; text-align: center;">视频介绍</h3>
          <div style="display:flex;gap:10px;align-items:center;margin-bottom:10px;">
            <input
              type="text"
              v-model="videoUrl"
              disabled
              placeholder="上传后自动填充文件地址"
              style="background: #f5f5f5; border: 1px solid #ccc; color: #000; padding: 4px 6px; flex:1;"
            />
            <el-button
              type="primary"
              icon="el-icon-upload"
              @click="openUploadModal"
              :disabled="switchType !== 1"
            >
              上传附件
            </el-button>
          </div>
          <!-- 预览区域：区分图片/视频 -->
          <div v-if="videoUrl" style="width:100%;background:#eee;min-height:200px;display:flex;align-items:center;justify-content:center;">
            <video
              v-if="isVideoFile(videoUrl)"
              :src="videoUrl"
              controls
              style="width: 100%; max-height:400px;"
            ></video>
            <img
              v-else
              :src="videoUrl"
              style="max-width:100%;max-height:400px;object-fit:contain;"
            />
          </div>
          <div v-else style="width:100%;background:#eee;height:200px;display:flex;align-items:center;justify-content:center;color:#999;">
            暂无上传视频/图片
          </div>
        </div>

        <!-- 上传弹窗 -->
        <el-dialog
          title="上传视频/图片"
          :visible.sync="uploadModalVisible"
          width="500px"
          destroy-on-close
          :before-close="handleDialogClose"
        >
          <el-upload
            class="upload-demo"
            action="/callComponent/upload/uploadFile/uploadImage"
            accept=".mp4,.avi,.mov,.jpg,.jpeg,.png,.gif"
            :limit="1"
            name="uploadFile"
            :data="uploadExtraParams"
            :file-list="fileListUpload"
            :on-success="handleUploadSuccess"
            :on-remove="handleRemove"
            :auto-upload="true"
            :on-exceed="handleExceed"
            :on-error="handleUploadError"
          >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">点击选择文件</div>
            <div class="el-upload__tip" slot="tip">
              支持 MP4/AVI/MOV 视频、JPG/PNG/GIF 图片，单个文件最大 100MB
            </div>
          </el-upload>
          <div slot="footer" class="dialog-footer">
            <el-button @click="uploadModalVisible = false">取消</el-button>
            <el-button
              type="primary"
              @click="handleConfirmUpload"
              :loading="uploadConfirmLoading"
            >
              确定使用该文件
            </el-button>
          </div>
        </el-dialog>

        <!-- 5. 园区简介 新增 maxlength="1000" -->
        <div style="border: 1px solid #ccc; padding: 15px; background: #fafafa;">
          <h3 style="margin: 0 0 15px 0; text-align: center;">园区简介</h3>
          <textarea
            v-model="introContent"
            :disabled="switchType !== 1"
            maxlength="1000"
            style="background: #fff; border: 1px solid #ccc; color: #000; padding: 6px; width: 100%; min-height: 120px; resize: none;"
          ></textarea>
          <div style="text-align: right; margin-top:5px; font-size:12px; color:#999;">已输入{{ introContent.length }}/300字</div>
        </div>

        <!-- 6. 园区资产 -->
        <div style="border: 1px solid #ccc; padding: 15px; background: #fafafa;">
          <h3 style="margin: 0 0 15px 0; text-align: center;">园区资产</h3>
          <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 10px;">
            <div v-for="(item, index) in assetList" :key="index" style="display: flex; flex-direction: column; gap: 4px;">
              <input
                type="text"
                v-model="item.name"
                :disabled="switchType !== 1"
                style="background: #fff; border: 1px solid #ccc; color: #000; padding: 3px 4px; text-align: center;"
              />
               <input
                type="text"
                v-model="item.value"
                :disabled="switchType !== 1"
                style="background: #fff; border: 1px solid #ccc; color: #000; padding: 3px 4px; text-align: center; font-size: 16px; font-weight: bold;"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- 右侧区域 -->
      <div style="flex: 0.9; display: flex; flex-direction: column; gap: 15px;">
        <!-- 7. 入驻企业（只读） -->
        <div style="border: 1px solid #ccc; padding: 15px; background: #fafafa;">
          <h3 style="margin: 0 0 15px 0; text-align: center;">入驻企业</h3>
          <div>
            <div v-if="companyNameList.length === 0">暂无入驻企业</div>
            <div v-else>
              <div v-for="(name, idx) in companyNameList" :key="idx" style="padding: 5px 0; border-bottom: 1px solid #eee;">
                {{ name }}
              </div>
            </div>
          </div>
        </div>

        <!-- 8. 行业分类分布 -->
        <div style="border: 1px solid #ccc; padding: 15px; background: #fafafa;">
          <h3 style="margin: 0 0 15px 0; text-align: center;">行业分类分布</h3>
          <div style="margin-bottom: 10px;">
            <div v-for="(item, index) in industryList" :key="index" style="display: flex; gap: 8px; margin: 6px 0;">
              <input
                type="text"
                v-model="item.name"
                :disabled="switchType !== 1"
                placeholder="行业名称"
                style="background: #fff; border: 1px solid #ccc; color: #000; padding: 4px 6px; flex: 1;"
              />
              <input
                type="number"
                v-model.number="item.value"
                :disabled="switchType !== 1"
                placeholder="数值"
                style="background: #fff; border: 1px solid #ccc; color: #000; padding: 4px 6px; width: 80px;"
              />
            </div>
          </div>
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="addIndustryItem"
            :disabled="switchType !== 1"
            style="width: 100%;"
          >
            添加行业
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Switch, Button, Message, Icon, Upload, Dialog } from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import { getObtainLargeScreenData, saveLargeScreenData, getCommunityId } from "@/api/community/communityApi";

Vue.use(Switch);
Vue.use(Button);
Vue.use(Icon);
Vue.use(Upload);
Vue.use(Dialog);
Vue.prototype.$message = Message;

export default {
  data() {
    return {
      communityId: "",
      switchType: 0, // 0=查看  1=编辑
      isSaving: false,

      overviewData: {
        totalArea: 0,
        totalHouse: 0
      },

      peopleTrendList: [
        { month: "1月", value: 0 },
        { month: "2月", value: 0 },
        { month: "3月", value: 0 },
        { month: "4月", value: 0 },
        { month: "5月", value: 0 },
        { month: "6月", value: 0 },
        { month: "7月", value: 0 },
        { month: "8月", value: 0 },
        { month: "9月", value: 0 },
        { month: "10月", value: 0 },
        { month: "11月", value: 0 },
        { month: "12月", value: 0 }
      ],
      // 水费12个月
      waterTrendList: [
        { month: "1月", value: 0 },
        { month: "2月", value: 0 },
        { month: "3月", value: 0 },
        { month: "4月", value: 0 },
        { month: "5月", value: 0 },
        { month: "6月", value: 0 },
        { month: "7月", value: 0 },
        { month: "8月", value: 0 },
        { month: "9月", value: 0 },
        { month: "10月", value: 0 },
        { month: "11月", value: 0 },
        { month: "12月", value: 0 }
      ],
      // 电费12个月
      electricTrendList: [
        { month: "1月", value: 0 },
        { month: "2月", value: 0 },
        { month: "3月", value: 0 },
        { month: "4月", value: 0 },
        { month: "5月", value: 0 },
        { month: "6月", value: 0 },
        { month: "7月", value: 0 },
        { month: "8月", value: 0 },
        { month: "9月", value: 0 },
        { month: "10月", value: 0 },
        { month: "11月", value: 0 },
        { month: "12月", value: 0 }
      ],

      videoUrl: "",
      introContent: "",
      // 默认4个空白输入项
      assetList: [
        { name: "", value: 0 },
        { name: "", value: 0 },
        { name: "", value: 0 },
        { name: "", value: 0 }
      ],
      companyNameList: [],
      industryList: [],
      originalData: {},

      // 上传弹窗相关变量
      uploadModalVisible: false,
      uploadConfirmLoading: false,
      fileListUpload: [],
      // 上传附加参数，固定携带communityId，允许为空
      uploadExtraParams: {
        communityId: ""
      },
      tempUploadUrl: "" // 临时存储上传成功的文件地址
    };
  },
  created() {
    this.communityId = getCommunityId();
    // 同步上传参数里的communityId
    this.uploadExtraParams.communityId = this.communityId || "";
    setTimeout(() => {
      this.fetchLargeScreenData();
    }, 300);
  },
  methods: {
    // 打开上传弹窗，刷新上传参数communityId
    openUploadModal() {
      // 每次打开弹窗都同步最新communityId，为空也传
      this.uploadExtraParams.communityId = this.communityId || "";
      this.uploadModalVisible = true;
    },

    // 判断文件是否为视频
    isVideoFile(url) {
      if (!url) return false;
      const videoSuffix = ["mp4", "avi", "mov"];
      const suffix = url.split(".").pop().toLowerCase();
      return videoSuffix.includes(suffix);
    },

    // 请求接口：携带 communityId
    async fetchLargeScreenData() {
      try {
        const params = {
          communityId: this.communityId,
        };
        const res = await getObtainLargeScreenData(params);
        const data = res.data || {};
        // 核心：baseData 是内层对象，所有视频、简介、资产都在 data.baseData 下
        const baseData = data.baseData || {};

        this.switchType = data.switchType || baseData.switch_type || 0;
        this.overviewData.totalArea = data.totalRoomArea || baseData.total_room_area || 0;
        this.overviewData.totalHouse = data.totalRoomCount || baseData.total_room_count || 0;

        // 1. 园区人数趋势
        const trendData = data.ownerTrendData || baseData.owner_trend_data || {};
        for (let i = 0; i < this.peopleTrendList.length; i++) {
          const item = this.peopleTrendList[i];
          item.value = Number(trendData[item.month]) || 0;
        }

        // ========== 修改点：水费取自 meterByTypeEcharts，电费取自 costByTypeEchartsMap ==========
        const waterData = data.meterByTypeEcharts || {};
        for (let i = 0; i < this.waterTrendList.length; i++) {
          const item = this.waterTrendList[i];
          item.value = Number(waterData[item.month]) || 0;
        }
        const electricData = data.costByTypeEchartsMap || {};
        for (let i = 0; i < this.electricTrendList.length; i++) {
          const item = this.electricTrendList[i];
          item.value = Number(electricData[item.month]) || 0;
        }

        // 修复：从 baseData 读取视频地址、园区简介
        this.videoUrl = baseData.video_url || "";
        this.introContent = baseData.intro_content || "";

        // 园区资产
        const assetCountData = data.assetCountData || baseData.asset_count_data || {};
        const assetEntries = Object.entries(assetCountData);
        for (let i = 0; i < 4; i++) {
          if (assetEntries[i]) {
            this.assetList[i].name = assetEntries[i][0];
            this.assetList[i].value = Number(assetEntries[i][1]) || 0;
          } else {
            this.assetList[i].name = "";
            this.assetList[i].value = 0;
          }
        }

        // 入驻企业
        this.companyNameList = Array.isArray(data.companyNameList) ? [...data.companyNameList] : [];

        // 行业分类分布
        const industryData = data.industryTypeData || baseData.industry_type_data || {};
        this.industryList = Object.keys(industryData).map(key => {
          return {
            name: key,
            value: Number(industryData[key]) || 0
          };
        });

        // 备份原始数据
        this.originalData = JSON.parse(JSON.stringify({
          overviewData: this.overviewData,
          peopleTrendList: this.peopleTrendList,
          waterTrendList: this.waterTrendList,
          electricTrendList: this.electricTrendList,
          videoUrl: this.videoUrl,
          introContent: this.introContent,
          assetList: this.assetList,
          companyNameList: this.companyNameList,
          industryList: this.industryList
        }));

      } catch (error) {
        console.error("数据获取异常：", error);
        this.$message.error("暂无数据");
      }
    },

    // 模式切换：赋值
    handleSwitchChange(val) {
      this.switchType = val;
    },

    addIndustryItem() {
      if (this.switchType !== 1) return;
      this.industryList.push({
        name: "新行业" + (this.industryList.length + 1),
        value: 0
      });
    },

    // 统一表单校验
    validateForm() {
      // 1. 园区概况：数字非负
      if (this.overviewData.totalArea === "" || this.overviewData.totalArea < 0) {
        this.$message.warning("房屋总面积不能为空且不能小于0");
        return false;
      }
      if (this.overviewData.totalHouse === "" || this.overviewData.totalHouse < 0) {
        this.$message.warning("房源总数不能为空且不能小于0");
        return false;
      }

      // 2. 园区人数趋势：全部数字非负
      for (let item of this.peopleTrendList) {
        if (item.value === "" || item.value < 0) {
          this.$message.warning(`${item.month} 人数不能为空且不能小于0`);
          return false;
        }
      }

      // 3. 水费校验
      for (let item of this.waterTrendList) {
        if (item.value === "" || item.value < 0) {
          this.$message.warning(`${item.month} 水费金额不能为空且不能小于0`);
          return false;
        }
      }
      // 电费校验
      for (let item of this.electricTrendList) {
        if (item.value === "" || item.value < 0) {
          this.$message.warning(`${item.month} 电费金额不能为空且不能小于0`);
          return false;
        }
      }

      // 4. 园区简介：必填 + 长度不超过1000字
      if (!this.introContent || this.introContent.trim() === "") {
        this.$message.warning("园区简介不能为空");
        return false;
      }
      if (this.introContent.length > 300) {
        this.$message.warning("园区简介最多只能输入300字");
        return false;
      }

      // 5. 园区资产：名称必填、数值非负
      for (let item of this.assetList) {
        if (!item.name || item.name.trim() === "") {
          this.$message.warning("资产名称不能为空");
          return false;
        }
        if (item.value === "" || item.value < 0) {
          this.$message.warning(`【${item.name}】数值不能为空且不能小于0`);
          return false;
        }
      }

      // 6. 行业分类：名称必填、数值非负
      for (let item of this.industryList) {
        if (!item.name || item.name.trim() === "") {
          this.$message.warning("行业名称不能为空");
          return false;
        }
        if (item.value === "" || item.value < 0) {
          this.$message.warning(`【${item.name}】数值不能为空且不能小于0`);
          return false;
        }
      }

      return true;
    },

    async handleSave() {
      // 执行校验
      if (!this.validateForm()) {
        return;
      }

      this.isSaving = true;
      try {
        // 组装人数趋势
        const ownerTrendData = {};
        this.peopleTrendList.forEach(item => {
          ownerTrendData[item.month] = item.value;
        });
        // ========== 修改点：组装水费meterByTypeEcharts、电费costByTypeEchartsMap ==========
        const meterByTypeEcharts = {};
        this.waterTrendList.forEach(item => {
          meterByTypeEcharts[item.month] = item.value;
        });
        const costByTypeEchartsMap = {};
        this.electricTrendList.forEach(item => {
          costByTypeEchartsMap[item.month] = item.value;
        });

        // 组装资产：原样输出，不去重
        const assetCountData = {};
        this.assetList.forEach(item => {
          assetCountData[item.name] = item.value;
        });

        // 组装行业
        const industryTypeData = {};
        this.industryList.forEach(item => {
          industryTypeData[item.name] = item.value;
        });

        // 提交参数：替换原有water/electricTrendData，新增meterByTypeEcharts、costByTypeEchartsMap
        const submitData = {
          communityId: this.communityId,
          switchType: this.switchType,
          totalRoomArea: this.overviewData.totalArea,
          totalRoomCount: this.overviewData.totalHouse,
          ownerTrendData: ownerTrendData,
          meterByTypeEcharts: meterByTypeEcharts, // 水费月数据
          costByTypeEchartsMap: costByTypeEchartsMap, // 电费月数据
          videoUrl: this.videoUrl,
          introContent: this.introContent,
          assetCountData: assetCountData,
          companyNameList: this.companyNameList,
          industryTypeData: industryTypeData
        };

        await saveLargeScreenData(submitData);
        this.$message.success("保存成功");
        await this.fetchLargeScreenData();
      } catch (err) {
        console.error("保存异常：", err);
        this.$message.error((err && err.response && err.response.data && err.response.data.message) || "保存失败，请重试");
      } finally {
        this.isSaving = false;
      }
    },

    resetData() {
      Object.assign(this.overviewData, this.originalData.overviewData);
      this.peopleTrendList = JSON.parse(JSON.stringify(this.originalData.peopleTrendList));
      this.waterTrendList = JSON.parse(JSON.stringify(this.originalData.waterTrendList));
      this.electricTrendList = JSON.parse(JSON.stringify(this.originalData.electricTrendList));
      this.videoUrl = this.originalData.videoUrl;
      this.introContent = this.originalData.introContent;
      this.assetList = JSON.parse(JSON.stringify(this.originalData.assetList));
      this.companyNameList = this.originalData.companyNameList;
      this.industryList = JSON.parse(JSON.stringify(this.originalData.industryList));
    },

    // ========== 上传弹窗相关方法 ==========
    // 关闭弹窗前清空上传缓存
    handleDialogClose() {
      this.fileListUpload = [];
      this.tempUploadUrl = "";
      this.uploadConfirmLoading = false;
    },
    // 文件超出数量限制
    handleExceed() {
      this.$message.warning("仅允许上传1个视频/图片文件");
    },
    // 移除上传文件
    handleRemove() {
      this.tempUploadUrl = "";
    },
    // 上传失败回调
    handleUploadError() {
      this.$message.error("文件上传失败，请检查文件大小或网络");
      this.fileListUpload = [];
      this.tempUploadUrl = "";
    },
    // 上传成功回调，取返回url
    handleUploadSuccess(res) {
      // 返回格式：{"url":"xxx","fileId":"xxx"}
      if (res && res.url) {
        this.tempUploadUrl = res.url;
        this.$message.success("文件上传完成");
      } else {
        this.$message.error("文件上传返回地址为空");
      }
    },
    // 弹窗确定，回填地址到videoUrl
    handleConfirmUpload() {
      if (!this.tempUploadUrl) {
        this.$message.warning("请先选择并上传文件");
        return;
      }
      this.uploadConfirmLoading = true;
      setTimeout(() => {
        this.videoUrl = this.tempUploadUrl;
        this.uploadModalVisible = false;
        this.uploadConfirmLoading = false;
        this.$message.success("已设置视频/图片地址");
      }, 300);
    }
  }
};
</script>